/**
 * 针对内存会话存储的操作
 * 
 */
export const setSessionStorage = (key, value) => {
	window.sessionStorage.setItem(key, JSON.stringify(value));
};
export const getSessionStorage = (key) => {
	const val = window.sessionStorage.getItem(key);
	return JSON.parse(val);
};
export const clearSessionStorage = (key) => {
	return window.sessionStorage.removeItem(key);
};
export const setLocalStorage = (key, value) => {
	window.localStorage.setItem(key, JSON.stringify(value));
};
export const getLocalStorage = (key) => {
	const val = window.sessionStorage.getItem(key);
	return JSON.parse(val);
};

// 验证身份证号码是否有效
// 身份证号码验证  如果是不对的就返回一个false可以做验证
export const checkIdCard = (idcard) => {
	if (idcard.length === 18) {
		const arrIdCard = idcard.split('');
		if (isValidityBrithBy18IdCard(idcard) && isTrueValidateCodeBy18IdCard(arrIdCard)) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};

export const isTrueValidateCodeBy18IdCard = (arrIdCard) => {
	// 第二代身份证，18位 XXXXXX yyyy MM dd 375 0
	// 1-6位为地区编码
	// 7-10  出身年份 4位，第一代身份证只有两位
	// 11-14 出身年月日 4位
	// 15-18 顺序码+校验码 18位身份证4位，最后一位可能是X, 15位身份证顺序码3位，没有校验码
	// 18位的身份证正则：
	// [1-9]\d{5}                 前六位地区，非0打头
	// (18|19|([23]\d))\d{2}      出身年份，覆盖范围为 1800-3999 年
	// ((0[1-9])|(10|11|12))      月份，01-12月
	// (([0-2][1-9])|10|20|30|31) 日期，01-31天
	// \d{3}[0-9Xx]：              顺序码三位 + 一位校验码
	let sum = 0;
	const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1];
	const ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
	// eslint-disable-next-line eqeqeq
	if (arrIdCard[17].toLowerCase() == 'x') {
		arrIdCard[17] = 10;
	}
	for (let i = 0; i < 17; i++) {
		sum += Wi[i] * arrIdCard[i];
	}
	const valCodePosition = sum % 11;
	// eslint-disable-next-line eqeqeq
	if (arrIdCard[17] == ValideCode[valCodePosition]) {
		return true;
	} else {
		return false;
	}
};
// 18位身份证有校性验证
export const isValidityBrithBy18IdCard = (idCard18) => {
	const year = idCard18.substring(6, 10);
	const month = idCard18.substring(10, 12);
	const day = idCard18.substring(12, 14);
	const TEMP_DATE = new Date(year, parseFloat(month) - 1, parseFloat(day));
	if (
		// eslint-disable-next-line eqeqeq
		TEMP_DATE.getFullYear() != parseFloat(year) ||
		// eslint-disable-next-line eqeqeq
		TEMP_DATE.getMonth() != parseFloat(month) - 1 ||
		// eslint-disable-next-line eqeqeq
		TEMP_DATE.getDate() != parseFloat(day)
	) {
		return false;
	} else {
		return true;
	}
};


// 时间转时间戳
export const turnTimestamp = (str) => {
	const date = new Date(str);
	const timestamp = date.getTime();
	return timestamp;
  };
  // 时间戳转时间
  export const turnDate = (datetime) => {
	const date = new Date(datetime); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
	const Year = date.getFullYear() + '-';
	const Month =
	(date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	const Date0 = date.getDate() + ' ';
	const Hours = date.getHours() + ':';
	const Minutes = date.getMinutes() + ':';
	const Seconds = date.getSeconds();
	return Year + Month + Date0 + Hours + Minutes + Seconds;
  };
